/**
 * Free-shipping threshold nudge — adds bridge samples toward the $99 free-ship line.
 * Uses ILCartEvents.addToCartWithTracking so Shopify WPM still emits product_added_to_cart
 * (no new tracking dependency). Delegated on document so it survives cart re-renders.
 */
(function () {
  if (window.__ilFsnInit) return;
  window.__ilFsnInit = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-freeship-add]');
    if (!btn || btn.hasAttribute('aria-busy')) return;
    e.preventDefault();

    var variantId = btn.getAttribute('data-variant-id');
    var qty = parseInt(btn.getAttribute('data-quantity') || '1', 10) || 1;
    if (!variantId) return;

    var drawer = btn.closest('cart-drawer');
    var prevOpacity = btn.style.opacity;
    btn.setAttribute('aria-busy', 'true');
    btn.style.opacity = '0.6';
    function done() { btn.removeAttribute('aria-busy'); btn.style.opacity = prevOpacity; }

    // Preferred path: tracked add (matches product-form.js so WPM fires add_to_cart)
    if (window.ILCartEvents && window.ILCartEvents.addToCartWithTracking) {
      window.ILCartEvents
        .addToCartWithTracking({ variantId: variantId, quantity: qty, cartTarget: drawer || undefined })
        .then(function (payload) {
          if (drawer && typeof drawer.renderContents === 'function') {
            drawer.renderContents(payload, true); // re-renders drawer + recomputes the nudge
          } else {
            window.location.reload(); // cart page: simplest correct refresh
          }
          done();
        })
        .catch(function () { done(); });
      return;
    }

    // Fallback if ILCartEvents is unavailable: plain add then reload
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
      .then(function () { window.location.reload(); })
      .catch(function () { done(); });
  });
})();
